import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { verifyToken } from "shared/api/client/orvalHelpers";
import { getCookie } from "shared/auth/utils/cookieUtils";

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const [isVerified, setIsVerified] = useState<boolean | null>(null);

  useEffect(() => {
    const token = getCookie("userToken");
    if (!token) {
      setIsVerified(false);
      return;
    }
    verifyToken(token).then(setIsVerified);
  }, []);

  if (isVerified === null) {
    return <div>Loading...</div>;
  }

  if (!isVerified) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
